import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    GetMerchantFeaturePreferenceRequestAction,
    GetMerchantFeaturePreferenceCompleteAction,
    UpdateMerchantFeaturePreferenceRequestAction,
    UpdateMerchantFeaturePreferenceCompleteAction,
} from "actions/merchant";

export interface IState
    extends IQuery<nuorder.collection.merchant_feature_config.MerchantFeatureConfig>,
        IMutate<nuorder.collection.merchant_feature_config.MerchantFeatureConfig> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantFeaturePreference = handleActions<IState, any>(
    {
        [MERCHANT.FEATURE_PREFERENCE.GET.REQUEST]: (
            state: IState,
            _action: GetMerchantFeaturePreferenceRequestAction
        ): IState => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.FEATURE_PREFERENCE.GET.COMPLETE]: (
            state: IState,
            action: GetMerchantFeaturePreferenceCompleteAction
        ): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
        [MERCHANT.FEATURE_PREFERENCE.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdateMerchantFeaturePreferenceRequestAction
        ): IState => {
            return {
                ...state,
                mutateStatus: RequestStatus.Active,
                mutateError: undefined,
            };
        },
        [MERCHANT.FEATURE_PREFERENCE.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateMerchantFeaturePreferenceCompleteAction
        ): IState => {
            return {
                ...state,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState
);
